import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useMainContext } from "../../../Context";
import { single, toggleMark, ShowContactData } from "../../../Utils/Apis";

export const useSingle = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [contactLoading, setContactLoading] = useState(true);
  const [form, setForm] = useState({ show: false });
  const [markLoading, setMarkLoading] = useState(false);
  const { slug } = useParams();
  const { post, isLogin } = useMainContext();

  const get = async () => {
    setLoading(true);
    const { data } = await post(single, { slug });
    setData(data);
    setLoading(false);
  };
  const getContactData = async () => {
    setContactLoading(true);
    const { data } = await post(ShowContactData, { slug });
    console.log(data);
    setContactLoading(false);
  };
  const handler = () => {
    if (isLogin()) {
      getContactData();
      setForm({ ...form, show: true });
    } else {
      toast.error("برای مشاهده ابتدا ثبت نام کنید");
    }
  };
  const toggle = async () => {
    setMarkLoading(true);
    const { status } = await post(toggleMark, { ads_id: data?.ads?.id });
    if (+status == 200) {
      setData({ ...data, mark: data.mark == "true" ? "false" : "true" });
    }
    setMarkLoading(false);
  };

  useEffect(() => {
    get();
  }, [slug]);

  return {
    data,
    loading,
    handler,
    markLoading,
    toggle,
    form,
    setForm,
    contactLoading,
    getContactData,
  };
};
export const useContactData = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ show: false });
  const { slug } = useParams();
  const { post, isLogin } = useMainContext();

  const get = async () => {
    setLoading(true);
    const { data } = await post(ShowContactData, { slug });
    setData(data);
    setLoading(false);
  };

  useEffect(() => {
    get();
  }, [slug]);

  return {
    data,
    loading,
    form,
    setForm,
  };
};
